import React, { useEffect, useState } from 'react';
import { Swiper } from 'swiper/react';
import { Navigation } from 'swiper';
import * as styles from './commentsSlider.module.scss';

interface Props {
  children: React.ReactNode;
  setSwiper: any;
  spaceBetween?: number;
  slidesPerView?: number | 'auto';
  centeredSlides?: boolean;
}

export const Carousel: React.FC<Props> = ({
  children,
  setSwiper,
  spaceBetween = 25,
  slidesPerView = 'auto',
  centeredSlides = false,
}) => {
  //   const [elNext, setElNext] = useState<any>(undefined);
  //   const [elPrev, setElPrev] = useState<any>(undefined);
  //   useEffect(() => {
  //     setElNext(document.getElementById('nextElSwiper'));
  //     setElPrev(document.getElementById('prevElSwiper'));
  //   }, []);

  //   if (elNext === undefined || elPrev === undefined) return null;
  return (
    <Swiper
      onSwiper={(swiper) => setSwiper(swiper)}
      slidesPerView={slidesPerView}
      centeredSlides={centeredSlides}
      spaceBetween={spaceBetween}
      modules={[Navigation]}
      style={{ maxWidth: '320px', overflow: 'visible' }}
    >
      {children}
    </Swiper>
  );
};
